import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, Text } from "@cinch-labs/design-system";
import { Env, readFromEnv } from "@cinch-nx/environments";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import Image from "next/image";
import cx from "classnames";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import styles from "./hero.module.css";
import { useEffect, useState } from "react";
import { Wrapper } from "@cinch-nx/shared-ui";
export var Hero = function(blok) {
    var title = blok.title, body = blok.body, image = blok.image;
    var hasImageFilename = image === null || image === void 0 ? void 0 : image.filename;
    var ref = useState(false), isAppRoute = ref[0], setIsAppRoute = ref[1];
    useEffect(function() {
        setIsAppRoute(window.location.pathname.includes("/app"));
    }, []);
    var trackEvent = useAnalytics().trackEvent;
    var handleClick = function(label, value) {
        trackEvent({
            eventName: "App footer links",
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "app cta",
                    label: label,
                    action: "view",
                    value: value
                }
            }
        });
    };
    var ref1;
    var _obj;
    return /*#__PURE__*/ _jsxs(Wrapper, _object_spread_props(_object_spread({}, storyblokEditable(blok)), {
        isSlim: true,
        className: {
            inner: cx(hasImageFilename ? styles.root : styles.singleTitleWrapper, (_obj = {}, _define_property(_obj, styles.singleTitleWrapper, !hasImageFilename), _define_property(_obj, styles.appRoot, isAppRoute), _obj))
        },
        children: [
            hasImageFilename && /*#__PURE__*/ _jsx("div", {
                className: cx(styles.imageWrapper, _define_property({}, styles.appImageWrapper, isAppRoute)),
                children: /*#__PURE__*/ _jsx(Image, {
                    src: image === null || image === void 0 ? void 0 : image.filename,
                    alt: (ref1 = image === null || image === void 0 ? void 0 : image.alt) !== null && ref1 !== void 0 ? ref1 : undefined,
                    layout: "fill",
                    priority: true,
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: cx(styles.heroContent, _define_property({}, styles.appHeroContent, isAppRoute)),
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        element: "h1",
                        className: cx(styles.title, _define_property({}, styles.appTitle, isAppRoute)),
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        className: cx(styles.body, _define_property({}, styles.appBody, isAppRoute)),
                        children: body
                    }),
                    isAppRoute && /*#__PURE__*/ _jsxs("div", {
                        className: styles.appHeroButtons,
                        children: [
                            /*#__PURE__*/ _jsx("a", {
                                href: readFromEnv(Env.IOSAppStoreUrl),
                                "aria-label": "app store badge",
                                onClick: function() {
                                    return handleClick("apple", "app store");
                                },
                                children: /*#__PURE__*/ _jsx(Image, {
                                    src: "https://a.storyblok.com/f/132543/384x114/7266ad02b3/download-app-store.png",
                                    height: 48,
                                    width: 164
                                })
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: readFromEnv(Env.AndroidAppStoreUrl),
                                onClick: function() {
                                    return handleClick("android", "google play");
                                },
                                "aria-label": "google play badge",
                                children: /*#__PURE__*/ _jsx(Image, {
                                    src: "https://a.storyblok.com/f/132543/564x168/9d227fc037/google-play-badge1.png",
                                    height: 48,
                                    width: 164
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
export default Hero;
